import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { defaultDataUnit, defaultDays, defaultFrom, defaultYear } from 'components/work/useWorkStatisticsState'
import WorkChart from 'components/work/WorkChart'
import WorkTable from 'components/work/WorkTable'
import { worksQuery, workStatisticsQuery } from 'hooks/work'
import { WorkType } from 'types/work'

export const Route = createFileRoute('/_auth/profile/sewing')({
  beforeLoad: async ({ context: { account, queryClient } }) => {
    const userId = account.id
    return await Promise.all([
      queryClient.ensureQueryData(
        workStatisticsQuery(userId, {
          workType: WorkType.SEWING_DOUBLE_NEEDLE,
          dataUnit: defaultDataUnit,
          year: defaultYear,
          from: defaultFrom,
          days: defaultDays,
        })
      ),
      queryClient.ensureQueryData(
        workStatisticsQuery(userId, {
          workType: WorkType.SEWING_LOCKSTITCH,
          dataUnit: defaultDataUnit,
          year: defaultYear,
          from: defaultFrom,
          days: defaultDays,
        })
      ),
      queryClient.ensureQueryData(
        worksQuery(userId, {
          workType: WorkType.SEWING_DOUBLE_NEEDLE,
          columnFilters: [],
          globalFilter: '',
          pagination: { pageIndex: 0, pageSize: 5 },
          sorting: [],
        })
      ),
      queryClient.ensureQueryData(
        worksQuery(userId, {
          workType: WorkType.SEWING_LOCKSTITCH,
          columnFilters: [],
          globalFilter: '',
          pagination: { pageIndex: 0, pageSize: 5 },
          sorting: [],
        })
      ),
    ])
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Stack gap="xl">
      <WorkChart workType={WorkType.SEWING} />
      <WorkTable workType={WorkType.SEWING} />
    </Stack>
  )
}
